export default __webpack_public_path__ + "static/header-676a024d048a2b2e0cbab5ff0f7ef313.png";